import { Dispatch, SetStateAction } from 'react';
import { Button } from '@givebutter/primitives/button';
import { SelectedPreset } from 'assets/js/pages/engage/workflows/types';
import { WorkflowStarter } from 'assets/js/pages/engage/workflows/utils/starterItems';
import { SuggestedWorkflowTypeEnum, WorkflowTriggerTypeEnum } from 'constants/workflows';
import { twMerge } from 'tailwind-merge';

interface WorkflowStarterItemProps {
    item:
        | WorkflowStarter<WorkflowTriggerTypeEnum, 'trigger'>
        | WorkflowStarter<SuggestedWorkflowTypeEnum, 'suggested'>;
    isSelected: boolean;
    setSelectedPreset: Dispatch<SetStateAction<SelectedPreset>>;
}

const WorkflowStarterItem = ({
    item,
    isSelected = false,
    setSelectedPreset,
}: WorkflowStarterItemProps) => {
    const { slug, icon, name, description } = item;

    return (
        <li>
            <Button
                variant="outline"
                color="neutral"
                className={twMerge(
                    'h-fit w-full justify-start gap-3 rounded-xl p-4 text-left hover:bg-gray-50',
                    isSelected && 'bg-gray-50',
                )}
                onClick={() => setSelectedPreset(slug)}
            >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-2xl">
                    {icon}
                </div>
                <div>
                    <p className="whitespace-pre-wrap">{name}</p>
                    <p className="whitespace-pre-wrap text-sm font-normal">{description}</p>
                </div>
            </Button>
        </li>
    );
};

export { WorkflowStarterItem };

export type { WorkflowStarterItemProps, WorkflowStarter };
